// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,



  //testing
  // API_Base_URL: 'https://apimcq.esdinfra.com/api/',
  // Image_Url: 'https://apimcq.esdinfra.com/'


  //live
  // API_Base_URL: 'https://api.testnest.co.in/api/',
  // Image_Url: 'https://api.testnest.co.in/'


   //captain staging
  API_Base_URL: 'https://testnestapi.esdinfra.com/api/',
  Image_Url: 'https://testnestapi.esdinfra.com/'



};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
